import { render, staticRenderFns } from "./ChildSide.vue?vue&type=template&id=5a1ae368&"
import script from "./ChildSide.vue?vue&type=script&lang=js&"
export * from "./ChildSide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports